__turbopack_context__.v({
  "caption": "IzAVPa_caption",
  "downloadIcon": "IzAVPa_downloadIcon",
  "image": "IzAVPa_image",
  "imageContainer": "IzAVPa_imageContainer",
  "imageContentContainer": "IzAVPa_imageContentContainer",
  "inactive": "IzAVPa_inactive",
  "loading": "IzAVPa_loading",
  "loadingIcon": "IzAVPa_loadingIcon",
  "restricted": "IzAVPa_restricted",
  "rightsMessage": "IzAVPa_rightsMessage",
});
